var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs__list"},_vm._l((_vm.tabsLength),function(index){return _c('div',{key:index,class:_vm.tabsClass(index),attrs:{"title":_vm.getTabsTitle(index)},on:{"click":function($event){return _vm.tabsChange(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }